import React from 'react';
import { Link } from 'react-router-dom';
import PageNotFoundImg from '../assets/page-not-found.jpg';
import { THEME } from '../utils/theme';


const PageNotFound = () => {
	return (
		<div style={styles.container}>
			<div style={styles.content}>
				<Link to="/" style={styles.link}>Go Back Home</Link>
				<img src={PageNotFoundImg} alt="Looks like you are off the map. Let`s get you back on track" style={styles.image}/>
			</div>
		</div>
	);
};

const styles = {
	container: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '100vh',
		padding: '20px',
		backgroundColor: THEME.background.light,
	},
	content: {
		textAlign: 'center',
		maxWidth: '100%',
		width: '100%',
	},
	link: {
		display: 'inline-block',
		color: THEME.primary.main,
		fontSize: 'clamp(14px, 4vw, 24px)',
		marginBottom: '20px',
		padding: '10px 20px',
		border: `2px solid ${THEME.primary.main}`,
		borderRadius: '8px',
		textDecoration: 'none',
		fontWeight: 'bold',
		transition: 'all 0.3s ease',
	},
	image: {
		maxWidth: '100%',
		height: 'auto',
		display: 'block',
		borderRadius: '8px',
		marginTop: '20px',
		boxShadow: `0 4px 6px ${THEME.shadow.light}`,
	},
};

export default PageNotFound;
